
import { useEffect } from 'react';
import {useAxios} from '../../hooks';
import moment from 'moment';

const useProdutos = () => {
    const {getApiEmitirNotas} = useAxios();

    useEffect(()=>{
        console.warn("[useProdutos depreciado]: Utilize a o useProdutos dentro da pasta componentes");
    },[true])

    const listarProdutosEstoque = async (termo, dataLimite) => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/produtos/v2', {
            params: {
                termo, dataLimite,
                tipoProduto: "MATERIA_PRIMA,SIMPLES"
            }
        });
        return result.data;
    }

    const listarEstoqueProdutoPorLote = async (termo, dataLimite = (moment().format("YYYY-MM-DD"))) =>{
        const api = await getApiEmitirNotas();
        const result = await api.get('/produtos/v2', {
            params: {termo, dataLimite, groupBy: "lote"}
        });
        return result.data;
    }

    const buscaHistoricoMovimentacoes = async (produto) =>{
        const api = await getApiEmitirNotas();
        const result = await api.get('/movimentacao-estoque/' + produto.uuid + '/historico', {});
        return result.data;
    }

    const adicionarSaldo = async (movimentacao) =>{
        const api = await getApiEmitirNotas();
        const result = await api.post('/movimentacao-estoque/', movimentacao);
        return result.data;
    }


    return {listarProdutosEstoque, listarEstoqueProdutoPorLote, buscaHistoricoMovimentacoes, adicionarSaldo};
}

export {useProdutos}